import { Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

/**
 * Estado compartilhado do layout do escritório: abre e fecha a gaveta de navegação no
 * celular. A barra do topo abre; o layout, a sidebar e a navegação fecham.
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly router = inject(Router);

  private readonly _navOpen = signal(false);
  readonly navOpen = this._navOpen.asReadonly();

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.closeNav());
  }

  openNav(): void {
    this._navOpen.set(true);
  }

  closeNav(): void {
    this._navOpen.set(false);
  }

  toggleNav(): void {
    this._navOpen.update((open) => !open);
  }
}
